var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.5178 0H13.9246C6.23424 0 0 6.23424 0 13.9246V51.5178C0 59.2081 6.23424 65.4424 13.9246 65.4424H51.5178C59.2081 65.4424 65.4424 59.2081 65.4424 51.5178V13.9246C65.4424 6.23424 59.2081 0 51.5178 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4027 54.3462H46.6473L32.8771 29.1014L18.7749 54.3462H8.04004L33.1243 9.22632L57.4027 54.3462ZM48.3118 51.5414H52.7089L36.8283 22.0284L34.4939 26.2072L48.3124 51.5414H48.3118ZM12.8076 51.5414H17.1287L31.2898 26.1911L29.1165 22.2067L12.8076 51.5414ZM30.7288 19.3063L32.906 23.2975L35.2515 19.0992L33.0837 15.0708L30.7288 19.3063Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.74 45.4648C34.6243 45.4648 36.1518 43.9373 36.1518 42.053C36.1518 40.1686 34.6243 38.6411 32.74 38.6411C30.8557 38.6411 29.3281 40.1686 29.3281 42.053C29.3281 43.9373 30.8557 45.4648 32.74 45.4648Z",
    fill: "#231F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.38a3739e023abd4fe9828556b9ae015a.svg";
export { ForwardRef as ReactComponent };